import { all, call } from 'redux-saga/effects';
import userSagas from './user/user.sagas';
import courseSagas from './course/course.sagas';
import quizSagas from './quiz/quiz.sagas';
import questionSagas from './question/question.sagas';
import imagesSagas from './images/images.sagas';
import answerSagas from './answer/answer.sagas';
import scoreSagas from './score/score.sagas';
import feedbackSagas from './feedback/feedback.sagas';

export default function* rootSaga() {
    yield all([
        call(userSagas),
        call(courseSagas),
        call(quizSagas),
        call(questionSagas),
        call(imagesSagas),
        call(answerSagas),
        call(scoreSagas),
        call(feedbackSagas),
    ]);
}
